export const slugRegex = /^[\da-z]+(?:-[\da-z]+)*$/;

/**
 * Get is a slug is a file, like favicon.ico
 *
 * @param slug string
 * @returns boolean
 */
export const getIsSlugAFile = (slug: string): boolean => {
  return slug.includes('.');
};
